<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 26 26"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path clip-rule="evenodd" d="M21.6335 21.3344C19.4513 23.5945 16.3898 25 13 25C9.39817 25 6.16697 23.4131 3.96739 20.9004C4.2204 20.6667 4.56949 20.4315 5.10159 20.2626C5.40678 20.1657 5.85063 20.0732 6.38829 19.9652L6.51506 19.9398L6.51524 19.9397C7.00876 19.8408 7.55815 19.7307 8.08723 19.5974C8.65948 19.4533 9.23495 19.2758 9.71194 19.0414C10.1745 18.8141 10.6322 18.4914 10.8424 18.009C11.0391 17.5573 11.0192 17.0974 10.9106 16.6521C10.8047 16.218 10.6021 15.7507 10.3847 15.2651L10.3001 15.0768C9.87171 14.1239 9.35761 12.9805 9.06882 11.4692C8.73028 9.69746 9.01402 8.1977 9.70893 7.15756C10.3956 6.12969 11.5153 5.5 12.9812 5.5C14.5297 5.5 15.6495 6.16442 16.32 7.20679C17.0011 8.26572 17.2499 9.76767 16.9173 11.467C16.6019 13.078 16.0752 14.2389 15.6488 15.1789L15.5813 15.3278C15.3668 15.802 15.1669 16.2552 15.0634 16.6773C14.9563 17.114 14.9406 17.5611 15.1344 18.0081C15.3241 18.4457 15.6698 18.7717 16.0538 19.0187C16.4384 19.2661 16.8928 19.4546 17.3509 19.6062C17.9599 19.8077 18.647 19.9635 19.2335 20.0966C19.5072 20.1587 19.759 20.2158 19.9708 20.2702C20.614 20.4357 21.0188 20.6968 21.2763 20.9281C21.4423 21.0772 21.5521 21.2171 21.6335 21.3344ZM22.3107 20.571C22.2153 20.4524 22.0946 20.3189 21.9446 20.1842C21.5687 19.8465 21.0205 19.5077 20.2199 19.3018C19.9538 19.2333 19.6716 19.1696 19.381 19.1039L19.381 19.1039C18.8215 18.9775 18.231 18.8441 17.665 18.6568C17.2463 18.5183 16.88 18.3611 16.5948 18.1777C16.309 17.9938 16.1357 17.8036 16.0519 17.6104C15.9722 17.4266 15.9604 17.2178 16.0346 16.9155C16.1124 16.5984 16.271 16.2294 16.4924 15.74L16.5633 15.5836C16.9919 14.6395 17.5604 13.387 17.8986 11.6591C18.2682 9.77117 18.0138 7.9916 17.161 6.66582C16.2976 5.32348 14.853 4.5 12.9812 4.5C11.198 4.5 9.75875 5.28287 8.87742 6.60204C8.0043 7.90893 7.71089 9.69069 8.08659 11.6569C8.39806 13.2869 8.95545 14.5255 9.38416 15.4782L9.47201 15.6738C9.695 16.1718 9.85824 16.5576 9.93907 16.8891C10.0172 17.2094 10.0048 17.4276 9.92558 17.6096C9.85969 17.7608 9.66852 17.9486 9.27094 18.1439C8.88777 18.3322 8.39184 18.4895 7.84302 18.6277C7.33877 18.7547 6.81264 18.8602 6.31487 18.96L6.31485 18.96L6.19134 18.9848C5.67019 19.0895 5.16717 19.1926 4.79901 19.3094C4.14863 19.5159 3.68014 19.8223 3.34021 20.1209C1.86942 18.129 1 15.666 1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13C25 15.8706 23.992 18.5058 22.3107 20.571ZM2.65398 20.8726C0.988778 18.6876 0 15.9593 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C8.78178 26 5.0328 23.9909 2.65773 20.8775L2.65349 20.8731L2.65332 20.8733C2.65332 20.8733 2.65353 20.8731 2.65398 20.8726Z" :fill="fill" fill-rule="evenodd"/>
  </svg>

</template>

<script>
export default {
  name: 'User',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
